import { useMemo } from 'react';
import {
  createIdToStepMap,
  getPaginatedGroupedTactics,
  groupTacticsByActionOrder,
} from '../TacticKanban.utils';
import { Tactic } from 'generated/maya.types';

type UseTacticKanbanGroupingParams = {
  tactics: Tactic[];
  page: number;
  pageSize: number;
};

const useTacticKanbanGrouping = ({
  tactics,
  page,
  pageSize,
}: UseTacticKanbanGroupingParams) => {
  const groupedTactics = useMemo(
    () => groupTacticsByActionOrder(tactics),
    [tactics],
  );

  const idToStepMap = useMemo(
    () => createIdToStepMap(groupedTactics),
    [groupedTactics],
  );

  const stepKeys = useMemo(
    () => Object.keys(groupedTactics),
    [groupedTactics],
  );

  const paginatedGroupedTactics = useMemo(
    () => getPaginatedGroupedTactics({
      groupedTactics,
      page,
      pageSize,
    }),
    [groupedTactics, page, pageSize],
  );

  return {
    groupedTactics,
    paginatedGroupedTactics,
    idToStepMap,
    stepKeys,
  };
};

export default useTacticKanbanGrouping;
